
export const reportConfigModel = 'report_config';

export const reportConfigEndpoints = {
  [reportConfigModel]: 'survey/report_config'
}

export const reportConfigStore = {
  selected: {
    [reportConfigModel]: undefined
  },
}
